import { render } from "./CollectionPanel.vue?vue&type=template&id=80cae514&scoped=true"
import script from "./CollectionPanel.vue?vue&type=script&lang=js"
export * from "./CollectionPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/collectionPanels.scss?vue&type=style&index=0&id=80cae514&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80cae514"]])

export default __exports__